export default "__VITE_ASSET__DVZpC5OC__"